import { useState } from 'react';

const faqs = [
  {
    q: '91麻豆免费视频网站是否需要注册才能观看？',
    a: '无需注册即可免费视频在线观看大部分内容。91麻豆免费视频网站致力于为用户提供最便捷的访问体验，打开网站即可浏览海量91免费在线视频资源，注册后可解锁收藏与历史记录等个性化功能。',
  },
  {
    q: '91免费视频网站的播放画质如何？是否支持高清？',
    a: '平台所有内容均支持免费高清视频在线播放，默认提供1080P高清画质。91在线观看视频网站采用先进的视频编码与CDN加速技术，确保在不同网络环境下都能获得流畅的观看体验，真正做到即点即播不缓冲。',
  },
  {
    q: '91福利在线视频与普通内容有什么区别？',
    a: '91福利在线视频是平台精选的优质内容频道，汇集了91免费视频网站最受欢迎的热门资源。福利频道内容经过编辑团队严格筛选，品质更高、更新更快，是体验91麻豆免费视频网站核心价值的绝佳入口。',
  },
  {
    q: '在线免费视频网站是否支持手机观看？',
    a: '完全支持。91麻豆免费视频网站已全面适配移动端，在手机浏览器中即可流畅观看所有内容。同时提供iOS与Android客户端APP下载，移动端体验更加出色，随时随地畅享免费视频在线观看。',
  },
];

export default function SectionFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于91麻豆免费视频网站的常见疑问解答</p>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-200 ${openIndex === i ? 'bg-primary-500 text-white rotate-180' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}